// 17 Oct 2026 (presenter console): phones run the stream delay behind the server, so they land with what viewers see of
// the presenter on the stream. Stamps the server decides at the time (the scheduled start, the end of a reveal) move by
// the delay; each moment shows from its stamp plus the delay. The answer window is stamped for phones already.
import type { StateSnapshot } from '@shared/types';

export function phoneSnapshot(s: StateSnapshot): StateSnapshot {
  const d = s.delayMs ?? 0;
  if (!d) return s;
  return {
    ...s,
    ...(typeof s.scheduledStartAt === 'number' ? { scheduledStartAt: s.scheduledStartAt + d } : {}),
    ...(typeof s.revealUntil === 'number' ? { revealUntil: s.revealUntil + d } : {}),
  };
}

/** Server time from which a phone may show this snapshot; 0 = now. */
export function dueAt(s: StateSnapshot): number {
  const d = s.delayMs ?? 0;
  if (!d) return 0;
  if (s.status === 'question') { const q = s.question ?? s.upcoming; return q ? q.startsAt - (s.preRollMs ?? 0) : 0; }
  if (s.status === 'reveal') return typeof s.closedAt === 'number' ? s.closedAt + d : 0;
  if (s.status === 'podium' || s.status === 'ended') return typeof s.endedAt === 'number' ? s.endedAt + d : 0;
  return 0;
}

/** On air's clock: a question (its intro, clock and clues) runs the delay ahead; the rest arrives as the server says. */
export const onAirNow = (s: StateSnapshot | undefined, now: number): number => (s?.status === 'question' ? now + (s.delayMs ?? 0) : now);
